import React from "react";
import CashPayLinkButton from "./CashPayLinkButton";
import CashPayDirectPay from "./CashPayDirectPay";
import ReferencePay from "./ReferencePay";

export default function CashPayCheckout({description , amount , disabled , selectedPay , setSelectedPay}) {
  return (
    <div style={{ padding: "2px" }}>

      <div style={{ marginBottom: "30px" }}>
        <CashPayLinkButton amount={amount} description={description} disabled={disabled} selectedPay={selectedPay} setSelectedPay={setSelectedPay}/>
        {/* <ReferencePay amount={amount} description={description} disabled={disabled} selectedPay={selectedPay} setSelectedPay={setSelectedPay}/> */}
      </div>
    </div>
  );
}